<template>
  <div class="fCol fullWidth jStart aStart uploadSection">
    <input type="file" ref="excelFile" accept=".xls,.xlsx" @input="getFile">
    <div class="fRow fullWidth aCenter jStart h">
      <div class="excel"></div>
      <div class="fCol jCenter aStart">
        <h3>آپلود اطلاعات {{fileForLabel}} در قالب فایل اکسل</h3>
        <div class="ddd">اطلاعات مورد نظر را در قالب فایل اکسل با پسوند .xlsx آپلود کنید</div>
      </div>
    </div>
    <div class="fRow fullWidth aCenter jStart" v-if="!uploading">
      <div class="b fRow jStart aCenter big active" refs="select" @click="selectFile">
        <i class="material-icons-round">table_view</i>
        <label>انتخاب فایل اکسل</label>
      </div>
      <div class="b fRow jStart aCenter" style="background-color: rgba(0,0,0,0.15)">
        <i class="material-icons-round">get_app</i>
        <label>فایل نمونه اطلاعات {{fileForLabel}}</label>
      </div>
    </div>
    <div class="fRow fullWidth aCenter jStart" v-if="uploading">
      <div class="waitToLoad fCol jCenter aCenter fullWidth">
        <div class="prog"></div>
        <span>در حال آپلود فایل اطلاعات {{fileForLabel}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploading: false,
      excel: null,
    };
  },
  watch: {
  },
  props: ['fileFor'],
  methods: {
    selectFile() {
      this.$refs.excelFile.click();
    },
    getFile() {
      [this.excel] = [this.$refs.excelFile.files[0]];
      const ext = this.excel.name.split('.').pop();
      if (ext === 'xls' || ext === 'xlsx') {
        this.uploading = true;
        setTimeout(() => {
          // this.$toast.success(`اطلاعات ${this.fileForLabel} با موفقیت آپلود شد`);
          this.$refs.excelFile.value = '';
          this.$emit('fileUploaded');
          this.uploading = false;
        }, 2000);
      } else {
        // this.$toast.error('لطفا یک فایل با پسوند .xls یا .xlsx انتخاب کنید');
        this.$refs.select.click();
        this.uploading = false;
      }
    },
  },
  computed: {
    fileForLabel() {
      let a = '';
      switch (this.fileFor) {
        case 'teacher': {
          a = 'اساتید';
          break;
        }
        case 'student': {
          a = 'دانشجویان';
          break;
        }
        case 'field': {
          a = 'گروه‌های کلاسی';
          break;
        }
        case 'class': {
          a = '‌کلاس‌ها';
          break;
        }
        default:
          break;
      }
      return a;
    },
  },
};
</script>

<style lang="scss" scoped>
$azadSecondary: #8e9bd6;
$azadPrimary: #2156ae;
$azadNormalText: #343434;
$azadDarkText: #131313;
$azadInvertText: #fafafa;
$azadError: rgb(194, 34, 34);
.uploadSection {
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  border: solid 2px rgba($color: #000000, $alpha: 0.15);
  input[type='file'] {
    display: none;
  }
  .h {
    margin-bottom: 16px;
    .excel {
      width: 40px;
      height: 40px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin-left: 16px;
      background-image: url('../assets/excel.svg');
    }
    h3 {
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-weight: bold;
      text-align: right;
    }
    .ddd {
      margin: 4px 0 0 0;
      padding: 0;
      font-size: 12px;
      font-weight: 300;
      text-align: right;
    }
  }
  .waitToLoad {
    padding: 32px 0;
    @keyframes prog {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .prog {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      animation: prog 1s linear infinite;
      border: solid 4px $azadPrimary;
      border-right-color: rgba($color: #000000, $alpha: 0.0);
    }
    span {
      padding: 8px 16px;
      border-radius: 16px;
      font-weight: 300;
      color: rgb(184, 184, 184);
      background-color: rgba($color: #ffffff, $alpha: 1);
    }
  }
}
</style>
